import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export function LogosFooter() {
  const { t } = useTranslation(['layout']);
  const detalle = useSelector((state) => state.applicationState.templateData.footer.detalle);

  const logos = detalle.filter((detalle) => detalle.categoria?.nombre === 'logos-institucionales');
  const renderLogos =
    logos &&
    logos.map((logo) =>
      logo.url ? (
        <a
          href={logo.url.startsWith('http') ? logo.url : `https://${logo.url}`}
          key={logo.id}
          rel='noreferrer'
          target='_blank'
        >
          <img
            alt={logo.tipoEnlace?.nombre}
            className='h-16 flex-initial'
            key={logo.tipoEnlace?.nombre}
            src={logo.valor}
          />
        </a>
      ) : (
        <img
          alt={logo.tipoEnlace?.nombre}
          className='h-16 flex-initial'
          key={logo.id}
          src={logo.valor}
        />
      )
    );
  const cols = logos.length;

  return <div className='md:gap-8 gap-4 py-8 flex flex-wrap justify-end'>{renderLogos}</div>;
}
